import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import classNames from 'classnames';

import { MarkdownFieldProps } from './MarkdownField.types';
import styles from './MarkdownField.module.scss';
import appFormStyles from 'components/form/appFormField.module.scss';
import { AppTextAreaField } from 'components/form/appTextAreaField';

export class MarkdownField extends React.Component<MarkdownFieldProps> {
  state = {
    isTouched: false,
  };

  handleEditorChange = (content: string) => {
    const { onMarkdownChange, name } = this.props;

    onMarkdownChange(name, content);
  };

  handleOnBlur = () => this.setState({ isTouched: true });

  render() {
    const { label, required: isRequired, value, isFieldTouched, name, validate } = this.props;
    const { isTouched } = this.state;

    const validators = (Array.isArray(validate) ? validate : [validate]) || [];
    const error = validators.reduce((acc, validator) => acc || validator(value), undefined);
    const isError = (isTouched || isFieldTouched) && error;

    const inputWrapperStyles = classNames(appFormStyles.inputWrapper, { [styles.error]: isError });
    const fieldContainerStyles = classNames(appFormStyles.appFormField, {
      [appFormStyles.error]: isError,
    });

    return (
      <>
        <AppTextAreaField
          name={name}
          label="Virtual Graduation Message"
          className={styles.hide}
          {...(validate && { validate })}
        />
        <div className={fieldContainerStyles}>
          <div className={appFormStyles.labelWrapper}>
            {label}
            {isRequired && <span>*</span>}
          </div>
          <div className={inputWrapperStyles}>
            <Editor
              value={value}
              apiKey={process.env.REACT_APP_TINY_MCE_EDITOR_API_KEY}
              init={{
                height: 350,
                menubar: true,
                plugins: [
                  'advlist autolink lists link image',
                  'charmap print preview anchor help',
                  'searchreplace visualblocks code',
                  'insertdatetime media table paste wordcount',
                ],
                toolbar: `undo redo | formatselect | bold italic | \
            link | alignleft aligncenter alignright | \
            bullist numlist outdent indent | help`,
              }}
              onEditorChange={this.handleEditorChange}
              onBlur={this.handleOnBlur}
            />
            {isError && <div className={appFormStyles.errorWrapper}>{error}</div>}
          </div>
        </div>
      </>
    );
  }
}
